import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { translations } from "@/i18n";

const I18nContext = createContext(null);

export function I18nProvider({ children }) {
    const [lang, setLang] = useState(() => localStorage.getItem("ops_lang") || "ar");
    const dir = lang === "ar" ? "rtl" : "ltr";

    useEffect(() => {
        document.documentElement.lang = lang;
        document.documentElement.dir = dir;
        localStorage.setItem("ops_lang", lang);
    }, [lang, dir]);

    const t = useCallback(
        (key) => (translations[lang] && translations[lang][key]) || translations.en[key] || key,
        [lang]
    );

    // Render a domain entity's localized name ({name_ar, name_en})
    const tn = useCallback(
        (obj) => {
            if (!obj) return "";
            return lang === "ar" ? obj.name_ar || obj.name_en : obj.name_en || obj.name_ar;
        },
        [lang]
    );

    const toggleLang = useCallback(() => setLang((l) => (l === "ar" ? "en" : "ar")), []);

    return (
        <I18nContext.Provider value={{ lang, dir, t, tn, toggleLang, setLang }}>
            {children}
        </I18nContext.Provider>
    );
}

export const useI18n = () => useContext(I18nContext);
